import axios from 'axios';
import { push } from 'react-router-redux';
import ReactGA from 'react-ga';

import * as types from 'misc/types';
import store from 'store';
import { popup_icon_type } from 'components/shared/popup/Popup';
import { getText } from 'misc/helpers';

export const API_URL = Object.freeze({
    SERVICE: process.env.REACT_APP_API_URL,
    CMS: 'https://service.digimail.se/Cms/api/v1/'
});

/**
 * Headers
 */
const smartrefill = axios.create({
    headers: {
        'x-smartrefill-api-version': '1',
        'x-smartrefill-company': 'Digimail',
        'x-smartrefill-country': 'sv',
        'x-smartrefill-inflow': 'web',
        'x-smartrefill-language': 'SE',
        'x-smartrefill-marketing-version': '3.0',
        'Content-Type': 'application/json'
    }
});

function url(resource, api_url_to_use = API_URL.SERVICE) {
    return api_url_to_use + resource;
}

function handleResponse(response) {
    return response;
}

function handleError(error) {
    const response = error.response;
    const errorMessage =
        response && response.data && response.data.message
            ? response.data.message
            : getText('ServiceUnavailable', 'Tjänsten är inte tillgänglig just nu, försök igen senare.');

    ReactGA.event({
        category: 'Error',
        action: window.location.pathname,
        label: errorMessage
    });

    if (response && response.status === 403) {
        let timeoutError = new Error('Oops... Du tog för lång tid på dig.');

        const text = getText('_inactivated_logout_Text', 'Du har loggats ut pga inaktivitet');

        store.dispatch({ type: 'RESET' });
        store.dispatch(push('/'));

        store.dispatch({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: text
            }
        });

        throw timeoutError;
    } else {
        throw new Error(errorMessage);
    }
}

export function location(resource, config = undefined) {
    return smartrefill
        .get(resource, config)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}

export function get(resource, config = undefined, api_url_to_use = API_URL.SERVICE) {
    return smartrefill
        .get(url(resource, api_url_to_use), config)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}

export function post(resource, body = undefined, api_url_to_use = API_URL.SERVICE) {
    return smartrefill
        .post(url(resource, api_url_to_use), body)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}

export function put(resource, body = undefined, api_url_to_use = API_URL.SERVICE) {
    return smartrefill
        .put(url(resource, api_url_to_use), body)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}

export function remove(resource, body = undefined, api_url_to_use = API_URL.SERVICE) {
    return smartrefill
        .delete(url(resource, api_url_to_use), body)
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}



// WEBPACK FOOTER //
// ./src/misc/endpoint.js